export default __webpack_public_path__ + "fonts/eye-on.svg";